const powers = [
  {
    icon: 'ri-government-line',
    title: '政府資源對接',
    description: '協助企業掌握補助、輔導與升級資源，降低資訊搜尋成本。',
    image: 'https://public.readdy.ai/ai/img_res/edited_5951c79a13a8cae581bbb79de2e286de_169b74cc.jpg'
  },
  {
    icon: 'ri-calculator-line',
    title: '財稅管理把關',
    description: '以合規財稅觀點協助企業規劃營運基礎，提升管理穩定度。',
    image: 'https://public.readdy.ai/ai/img_res/edited_4e8091ee09cb6d41984fd6423ead1e28_4a05885d.jpg'
  },
  {
    icon: 'ri-cpu-line',
    title: 'AI 數位導入',
    description: '協助企業建立 AI 工作流程、知識庫與內部效率工具。',
    image: 'https://public.readdy.ai/ai/img_res/edited_fe8eb85db47c51112ac7034a2457bdd0_bbb0e5d2.jpg'
  },
  {
    icon: 'ri-leaf-line',
    title: 'ESG 永續規劃',
    description: '協助企業面對供應鏈減碳、碳盤查與永續管理需求。',
    image: 'https://public.readdy.ai/ai/img_res/edited_6ff5bc0ef267f9d9014395b57a028b91_84755517.jpg'
  },
  {
    icon: 'ri-rocket-line',
    title: '專案落地陪跑',
    description: '從診斷、企劃、文件撰寫到執行驗收，提供完整顧問支持。',
    image: 'https://public.readdy.ai/ai/img_res/edited_b6e4df47ebacb2e9ee97819528e93c97_0340b5e5.jpg'
  },
];

export default function FivePowersSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4 leading-tight">
            五力聯動，陪企業走過升級轉型的每一步
          </h2>
          <p className="text-sm md:text-base text-foreground-700 max-w-3xl mx-auto leading-relaxed">
            企業成長不只是找到資源，更重要的是能否判斷適合自己的方向，並把計畫真正落實。得運智科以「產官學資源、財稅管理、AI 應用、ESG 永續、專案執行」五大能力為核心，協助企業降低資訊落差，提升申請與導入效率，讓老闆能更專注於本業經營。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {powers.slice(0, 3).map((power) => (
            <div
              key={power.title}
              className="group relative rounded-xl overflow-hidden aspect-square cursor-pointer"
            >
              <img
                src={power.image}
                alt={power.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 via-primary-900/30 to-primary-900/5" />
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500/25 mb-3">
                  <i className={`${power.icon} text-accent-500 text-lg`} />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-white mb-2">
                  {power.title}
                </h3>
                <p className="text-sm text-white/95 leading-relaxed">
                  {power.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto mt-6">
          {powers.slice(3).map((power) => (
            <div
              key={power.title}
              className="group relative rounded-xl overflow-hidden aspect-square cursor-pointer"
            >
              <img
                src={power.image}
                alt={power.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 via-primary-900/30 to-primary-900/5" />
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500/25 mb-3">
                  <i className={`${power.icon} text-accent-500 text-lg`} />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-white mb-2">
                  {power.title}
                </h3>
                <p className="text-sm text-white/95 leading-relaxed">
                  {power.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}